import { ChangeEvent, useEffect, useState } from 'react';
import { Button, ButtonVariants } from '../../../Atoms/Button';
import { If } from '../../../Atoms/Conditionals';
import { useCommunityQACtx } from './community-context/comment-context';
import { Disclaimer } from './disclaimer';
import CommunityQAServices from './services/community-qa.service';
import { StatusType } from './utils/types';
interface UserNameModalProps {
  setUserModal: (value: boolean) => void;
}

export const UserNameModal = ({ setUserModal }: UserNameModalProps) => {
  const [suggestedUser, setSuggestedUserName] = useState<string[]>([]);
  const [selectedUserName, setSelectedUserName] = useState<string>('');
  const [errorStatusCode, setErrorStatusCode] = useState<string>('');
  const { setCurrentUserName } = useCommunityQACtx();

  useEffect(() => {
    nameSuggestionApi();
  }, []);

  const nameSuggestionApi = async () => {
    CommunityQAServices.usernameSuggestion().then((response) => {
      if (response.status === StatusType.Success) {
        setSuggestedUserName(response.data.suggestions);
      } else {
        console.log('something went wrong');
      }
    });
  };

  const handleUserName = (e: ChangeEvent<HTMLInputElement>) => {
    setSelectedUserName(e.target?.value);
  };

  const handleNameTags = (e: React.MouseEvent | React.TouchEvent) => {
    const target = e.target as HTMLElement;
    if (target.tagName === 'SPAN') {
      setSelectedUserName(target.textContent || '');
    }
  };

  const handleSaveUsername = async () => {
    const payload = {
      username: selectedUserName,
    };

    CommunityQAServices.setUserName(payload).then((response) => {
      if (response.status === StatusType.Success) {
        setCurrentUserName(selectedUserName);
        setUserModal(false);
      } else if (response.status === StatusType.Duplicate) {
        setErrorStatusCode(StatusType.Duplicate);
      } else {
        setErrorStatusCode(StatusType.Failed);
      }
    });
  };

  return (
    <div className="p-9">
      <h4 className="font-semibold text-s-20 mb-2 text-font-500">
        Enter Username
      </h4>
      <p className="mb-4 text-font-200 text-base font-medium">
        Please select a username that will be displayed publicly when you
        comment
      </p>
      <p className="mb-3 text-green-450 text-base font-medium">
        You can choose suggested name below.
      </p>
      <div
        className="flex flex-wrap gap-3 mb-6"
        onClick={handleNameTags}
        data-testid="nameTag"
      >
        {suggestedUser?.map((name: string) => {
          return (
            <span
              key={name}
              className="px-3 py-2 text-s-14 bg-grey-380 rounded-3xl cursor-pointer"
            >
              {name}
            </span>
          );
        })}
      </div>
      <div className="p-4 border border-blue-350 rounded-md flex">
        <input
          placeholder="Enter username"
          className="w-[66%] pr-5 outline-none"
          onChange={handleUserName}
          value={selectedUserName}
        />
        <Button
          variant={ButtonVariants.bluefilled}
          rounded="md"
          className="py-2.5 w-[34%] ml-3"
          onClick={handleSaveUsername}
        >
          Save
        </Button>
      </div>
      <If condition={errorStatusCode === StatusType.Duplicate}>
        <Disclaimer
          icon="https://assets.clear.in/cleartax/images/1713436905_info2.svg"
          text="This username is already taken"
          textColor="red"
        />
      </If>
      <If condition={errorStatusCode === StatusType.Failed}>
        <Disclaimer
          icon="https://assets.clear.in/cleartax/images/1713436905_info2.svg"
          text="Something went wrong"
          textColor="red"
        />
      </If>
    </div>
  );
};
